import { Controller } from '@hotwired/stimulus'

// Provides immediate feedback when uploading images by showing filename and preview.
export default class extends Controller {
  static targets = ['input', 'preview', 'placeholder', 'filename']

  connect() {
    this.initialSrc = this.previewTarget?.getAttribute('src') || null
    this.initialText = this.filenameTarget?.textContent?.trim() || ''
    this.toggle()
  }

  update() {
    const file = this.inputTarget.files[0]
    if (!file) {
      this.reset()
      return
    }

    if (this.filenameTarget) {
      this.filenameTarget.textContent = file.name
    }

    if (this.previewTarget && file.type.startsWith('image/')) {
      const reader = new FileReader()
      reader.onload = event => {
        this.previewTarget.src = event.target?.result || ''
        this.toggle(true)
      }
      reader.readAsDataURL(file)
    } else {
      this.toggle(false)
    }
  }

  reset() {
    if (this.filenameTarget) {
      this.filenameTarget.textContent = this.initialText || 'No file selected'
    }

    if (this.previewTarget) {
      this.previewTarget.src = this.initialSrc || ''
    }

    this.toggle(this.initialSrc?.length > 0)
  }

  toggle(forceShowImage) {
    const showImage = forceShowImage ?? (this.previewTarget?.getAttribute('src') || '').length > 0
    if (this.previewTarget) {
      this.previewTarget.classList.toggle('hidden', !showImage)
    }
    if (this.placeholderTarget) {
      this.placeholderTarget.classList.toggle('hidden', showImage)
    }
  }
}
